import wbsBookingsApi from '../apis/wbsBookingsApi';

const forgotPasswordsService = async (email: string): Promise<void> => {
  await wbsBookingsApi.post('/passwords/forgot', { email });
};

export default forgotPasswordsService;
